import api, { handleApiError } from './client';

export const dashboardService = {
  getStats: async () => {
    try {
      const response = await api.get('/api/dashboard/stats');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Dashboard stats error:', error);
      return handleApiError(error, 'Errore nel caricamento dei dati del dashboard');
    }
  },
};

export default dashboardService;
